const currentUserDefaultState = {
  isTrialPlan: false,
}

export default currentUserDefaultState
